module.exports = __webpack_public_path__ + "img/icipe-logo-web-200px-jpg.fead2257.jpg";